<template lang="pug">
filter-detail-container(:title="$t('filter_rating')" @back="back" @save="save" @clear="clear" :saveMode="false")
  template(v-slot:body)
    .pa-6
      .text-md.font-normal.mb-4 {{ $t('choose_rating_to_filter') }}
      div(v-for="star in totalStar" :key="star")
        .d-flex.align-center.text-sm.pa-6.cursor-pointer.hover-bg(@click="onSelect(getStarValue(star))")
          yc-checkbox.mr-4(v-model="selected" :value="getStarValue(star)")
          star-generator.mr-4(:totalStar="totalStar" :star="getStarValue(star)" :size="20" classes="mx-1")
          .text-md.font-normal {{ getStarValue(star) }} {{ 'star' | pluralize({ count:getStarValue(star) }) }}
        v-divider
</template>

<script>
import FilterDetailContainer from '@/components/connect/FilterDetailContainer.vue'
import StarGenerator from '@/components/review/general/StarGenerator.vue'

export default {
  name: 'FilterRating',
  components: {
    FilterDetailContainer,
    StarGenerator
  },
  props: {
    filter: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      totalStar: 5,
      selected: []
    }
  },
  mounted() {
    if (this.filter.items) {
      this.selected = [...this.filter.items]
    }
  },
  methods: {
    getStarValue(star) {
      return this.totalStar - star + 1
    },
    onSelect(star) {
      if (this.selected.includes(star)) {
        this.selected = this.selected.filter(x => x !== star)
      } else {
        this.selected.push(star)
      }
    },
    save() {
      const filter = {}
      if (this.selected.length) {
        filter['items'] = this.selected
      }
      this.$emit('update:filter', filter)
      this.back()
    },
    back() {
      this.$emit('onBack')
    },
    clear() {
      this.selected = []
    }
  }
}
</script>

<style scoped>
</style>